"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var tizen_types_1 = require("./tizen-types");
var utils = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var PLAYER_ELEMENT_ID = 'av-player';
var PLAYER_ELEMENT_TYPE = 'application/avplayer';
var TizenPlayer = (function (_super) {
    __extends(TizenPlayer, _super);
    function TizenPlayer(context, frameworkUtils) {
        if (frameworkUtils === void 0) { frameworkUtils = utils; }
        var _this = _super.call(this) || this;
        _this.context = context;
        _this.frameworkUtils = frameworkUtils;
        _this.currentTime = -1;
        if (_this.tizenGetState() !== tizen_types_1.AvPlayPlayerState.None) {
            _this.tizenClose();
        }
        else {
            _this.context.webapis.avplay.setListener({
                onbufferingstart: function () {
                    _this.onbufferingstart();
                },
                onbufferingprogress: function () {
                    return;
                },
                onbufferingcomplete: function () {
                    _this.onbufferingcomplete();
                },
                oncurrentplaytime: function (time) {
                    if (_this.isBuffering) {
                        return;
                    }
                    if (_this.nativeLoadData.type === client_lib_js_player_addons_common_player_1.PlaybackType.Live) {
                        _this.onLiveCurrentTime(time);
                    }
                    else {
                        _this.onVodCurrentTime(time);
                    }
                },
                onstreamcompleted: function () {
                    _this.onstreamcompleted();
                },
                ondrmevent: function (drmEvent, drmData) {
                    _this.ondrmevent(drmEvent, drmData);
                },
                onevent: function (eventid, data) {
                    _this.onevent(eventid, data);
                },
                onerror: function (eventid) {
                    _this.onerror(eventid);
                },
            });
        }
        return _this;
    }
    TizenPlayer.prototype.initiateSeek = function (seconds) {
        if (this.isInValidState([tizen_types_1.AvPlayPlayerState.Idle, tizen_types_1.AvPlayPlayerState.Ready, tizen_types_1.AvPlayPlayerState.Playing, tizen_types_1.AvPlayPlayerState.Paused])) {
            var playbackPosition = seconds ? seconds * 1000 : 0;
            this.context.webapis.avplay.seekTo(playbackPosition);
        }
    };
    TizenPlayer.prototype.nativeStop = function () {
        this.tizenStop();
        this.tizenClose();
        this.videoElement = null;
        this.frameworkUtils.removeFromBody(PLAYER_ELEMENT_ID);
        this.currentBitRate = undefined;
        this.stateChanged(client_lib_js_player_addons_common_player_1.PlayerState.Stopped);
    };
    TizenPlayer.prototype.nativePause = function () {
        if (this.isInValidState([tizen_types_1.AvPlayPlayerState.Playing])) {
            this.context.webapis.avplay.pause();
            if (this.tizenGetState() === tizen_types_1.AvPlayPlayerState.Paused) {
                this.stateChanged(client_lib_js_player_addons_common_player_1.PlayerState.Paused);
            }
        }
    };
    TizenPlayer.prototype.nativePlay = function () {
        if (this.isInValidState([tizen_types_1.AvPlayPlayerState.Ready, tizen_types_1.AvPlayPlayerState.Paused])) {
            this.context.webapis.avplay.play();
            if (this.tizenGetState() === tizen_types_1.AvPlayPlayerState.Playing) {
                this.stateChanged(client_lib_js_player_addons_common_player_1.PlayerState.Playing);
            }
        }
    };
    TizenPlayer.prototype.initialise = function () {
        return Promise.resolve();
    };
    TizenPlayer.prototype.nativeLoad = function (nativeLoadData) {
        var _this = this;
        this.stateChanged(client_lib_js_player_addons_common_player_1.PlayerState.Loading);
        this.isBuffering = false;
        this.isFirstBufferingEndEvent = true;
        this.nativeLoadData = nativeLoadData;
        this.nextAudioTrackId = undefined;
        var webapis = this.context.webapis;
        this.createVideoElement();
        this.tizenClose();
        webapis.avplay.open(nativeLoadData.cdn.url);
        this.setPlayoutRect(nativeLoadData.custom && nativeLoadData.custom.playoutRect);
        webapis.avplay.setStreamingProperty('ADAPTIVE_INFO', '|STARTBITRATE=AVERAGE');
        try {
            this.setupDRM(nativeLoadData.drmConfiguration);
        }
        catch (error) {
            return this.onerror(tizen_types_1.AvPlayError.NotSupportedFormat);
        }
        webapis.avplay.prepareAsync(function () {
            if (nativeLoadData.position && nativeLoadData.position * 1000 < _this.context.webapis.avplay.getDuration()) {
                webapis.avplay.seekTo(nativeLoadData.position * 1000, function () {
                    _this.autoplay(nativeLoadData);
                }, function (error) { return _this.handleWebAPIError(error); });
            }
            else {
                _this.autoplay(nativeLoadData);
            }
        }, function (error) { return _this.handleWebAPIError(error); });
    };
    TizenPlayer.prototype.nativeSetAudioTrack = function (trackId) {
        var audioTrack = this.getAudioTracks().find(function (candidate) { return candidate.trackId === trackId; });
        if (audioTrack) {
            if (this.isInValidState([tizen_types_1.AvPlayPlayerState.Playing]) && !this.isBuffering) {
                this.context.webapis.avplay.setSelectTrack(tizen_types_1.AvPlayStreamType.Audio, parseInt(trackId, 10));
                this.notifyCurrentAudioTrackChanged(trackId);
                this.nextAudioTrackId = undefined;
            }
            else {
                this.nextAudioTrackId = trackId;
            }
        }
    };
    TizenPlayer.prototype.dispose = function () {
        this.nativeStop();
        return Promise.resolve();
    };
    TizenPlayer.prototype.getFullScreenPlayoutRect = function () {
        return {
            x: 0,
            y: 0,
            width: this.context.document.body.clientWidth,
            height: this.context.document.body.clientHeight,
        };
    };
    TizenPlayer.prototype.setPlayoutRect = function (playoutRect) {
        var rect = playoutRect || this.getFullScreenPlayoutRect();
        this.context.webapis.avplay.setDisplayRect(rect.x, rect.y, rect.width, rect.height);
        this.setPlayerStyle(rect);
    };
    TizenPlayer.prototype.nativeSetVolume = function (volume) {
        return;
    };
    TizenPlayer.prototype.stateChanged = function (state) {
        if (state === null || this.currentState === state) {
            return;
        }
        this.currentState = state;
        this.notifyStateChange(this.currentState);
    };
    TizenPlayer.prototype.autoplay = function (nativeLoadData) {
        if (nativeLoadData.autoplay) {
            this.play();
        }
    };
    TizenPlayer.prototype.setAudioTrackAfterBuffering = function () {
        var audioTracks = this.getAudioTracks();
        if (!audioTracks || !audioTracks.length) {
            return;
        }
        this.notifyAvailableAudioTracksChanged(audioTracks);
        this.setDefaultAudioTrack(audioTracks);
    };
    TizenPlayer.prototype.setDefaultAudioTrack = function (tracks) {
        var _this = this;
        var defaultAudioLanguage;
        var nativeDefaultAudioLanguage = this.nativeLoadData.defaultAudioLanguage;
        if (Array.isArray(nativeDefaultAudioLanguage)) {
            defaultAudioLanguage = this.getFirstAvailableLanguage(nativeDefaultAudioLanguage, tracks);
        }
        else {
            defaultAudioLanguage = nativeDefaultAudioLanguage;
        }
        if (defaultAudioLanguage) {
            var audioTrack_1 = tracks.find(function (at) { return at.language === defaultAudioLanguage; });
            if (audioTrack_1) {
                this.nativeWaitForState([tizen_types_1.AvPlayPlayerState.Playing]).then(function () { return _this.nativeSetAudioTrack(audioTrack_1.trackId); });
            }
        }
        else {
            var currentAudioTrack = this.context.webapis.avplay.getCurrentStreamInfo().find(function (track) { return track.type === tizen_types_1.AvPlayStreamType.Audio; });
            if (currentAudioTrack) {
                this.notifyCurrentAudioTrackChanged(this.transformAudioTrack(currentAudioTrack).trackId);
            }
        }
    };
    TizenPlayer.prototype.getFirstAvailableLanguage = function (defaultAudioLanguages, audioTracks) {
        return defaultAudioLanguages.find(function (language) { return audioTracks.find(function (track) { return track.language === language; }) !== undefined; });
    };
    TizenPlayer.prototype.nativeWaitForState = function (validStates) {
        var _this = this;
        return new Promise(function (resolve) {
            var checkValidState = function () {
                if (_this.isInValidState(validStates)) {
                    return resolve();
                }
                setTimeout(checkValidState, 100);
            };
            setTimeout(checkValidState, 100);
        });
    };
    TizenPlayer.prototype.tizenClose = function () {
        try {
            this.context.webapis.avplay.close();
        }
        catch (error) {
            var errorString = error ? error.toString() : 'unknown reason';
            this.notifyWarning('TIZEN_CLOSE', "error closing player: " + errorString);
        }
    };
    TizenPlayer.prototype.tizenStop = function () {
        try {
            this.context.webapis.avplay.stop();
        }
        catch (error) {
            var errorString = error ? error.toString() : 'unknown reason';
            this.notifyWarning('TIZEN_STOP', "error stoping video: " + errorString);
        }
    };
    TizenPlayer.prototype.tizenGetState = function () {
        try {
            return this.context.webapis.avplay.getState();
        }
        catch (error) {
            var errorString = error ? error.toString() : 'unknown reason';
            this.notifyWarning('TIZEN_GETSTATE', "error getting tizen state: " + errorString);
            return null;
        }
    };
    TizenPlayer.prototype.isInValidState = function (validStates) {
        var state = this.tizenGetState();
        return validStates.indexOf(state) !== -1;
    };
    TizenPlayer.prototype.setupDRM = function (drmConfiguration) {
        if (drmConfiguration) {
            this.context.webapis.avplay.setDrm(tizen_types_1.AvPlayDrmType.Playready, tizen_types_1.AvPlayDrmOperation.SetProperties, JSON.stringify({
                DeleteLicenseAfterUse: true,
                LicenseServer: drmConfiguration.licenceAcquisitionUrl,
                CustomData: drmConfiguration.customChallengeData,
            }));
        }
    };
    TizenPlayer.prototype.onbufferingstart = function () {
        this.isBuffering = true;
        if (this.tizenGetState() === tizen_types_1.AvPlayPlayerState.Playing) {
            this.stateChanged(client_lib_js_player_addons_common_player_1.PlayerState.Rebuffering);
        }
    };
    TizenPlayer.prototype.onbufferingcomplete = function () {
        var _this = this;
        this.isBuffering = false;
        if (this.isFirstBufferingEndEvent) {
            this.isFirstBufferingEndEvent = false;
            this.nativeWaitForState([tizen_types_1.AvPlayPlayerState.Playing]).then(function () { return _this.setAudioTrackAfterBuffering(); });
        }
        if (this.tizenGetState() === tizen_types_1.AvPlayPlayerState.Playing) {
            this.stateChanged(client_lib_js_player_addons_common_player_1.PlayerState.Playing);
            if (this.nextAudioTrackId) {
                this.nativeSetAudioTrack(this.nextAudioTrackId);
            }
        }
    };
    TizenPlayer.prototype.onVodCurrentTime = function (time) {
        if (this.currentTime !== time) {
            this.currentTime = time;
            this.notifyCurrentPositionChanged(time / 1000);
            this.notifyDurationChanged(this.context.webapis.avplay.getDuration() / 1000);
        }
    };
    TizenPlayer.prototype.onLiveCurrentTime = function (time) {
        var absoluteServerTime = parseFloat(this.context.webapis.avplay.getStreamingProperty(tizen_types_1.AvPlayStreamingPropertyType.GetAbsoluteServerTime));
        var serverTimeScale = parseFloat(this.context.webapis.avplay.getStreamingProperty(tizen_types_1.AvPlayStreamingPropertyType.GetServerTimeScale));
        var normalisedServerTime = absoluteServerTime / serverTimeScale;
        var normalisedTime = time / 1000;
        this.notifyCurrentPositionChanged(normalisedServerTime + normalisedTime);
    };
    TizenPlayer.prototype.ondrmevent = function (drmEvent, drmData) {
        if (drmData.name === 'Challenge') {
            var drmParam = {
                ResponseMessage: drmData.message,
            };
            this.context.webapis.avplay.setDrm(tizen_types_1.AvPlayDrmType.Playready, tizen_types_1.AvPlayDrmOperation.InstallLicense, JSON.stringify(drmParam));
        }
    };
    TizenPlayer.prototype.onstreamcompleted = function () {
        this.tizenStop();
        this.stateChanged(client_lib_js_player_addons_common_player_1.PlayerState.Finished);
    };
    TizenPlayer.prototype.onerror = function (eventid) {
        this.raiseErrorAndStop({ code: eventid, message: null, isFatal: true });
    };
    TizenPlayer.prototype.onevent = function (eventid, data) {
        if (eventid === tizen_types_1.AvPlayEvent.MsgBitrateChange || eventid === tizen_types_1.AvPlayEvent.MsgResolutionChanged) {
            var streamInfo = this.context.webapis.avplay.getCurrentStreamInfo();
            if (streamInfo) {
                var videoStreamInfo = streamInfo.find(function (_a) {
                    var type = _a.type;
                    return type === tizen_types_1.AvPlayStreamType.Video;
                });
                if (videoStreamInfo) {
                    var extraInfo = videoStreamInfo.extra_info && JSON.parse(videoStreamInfo.extra_info);
                    if (extraInfo.Bit_rate) {
                        var bitrate = parseInt(extraInfo.Bit_rate, 0) / 1000;
                        if (bitrate !== this.currentBitRate) {
                            this.currentBitRate = bitrate;
                            this.notifyBitrateChanged({ bitrateKbps: this.currentBitRate });
                        }
                    }
                }
            }
        }
    };
    TizenPlayer.prototype.handleWebAPIError = function (error) {
        this.raiseErrorAndStop({
            code: error.code && error.code.toString(),
            message: error.message,
            isFatal: true,
        });
    };
    TizenPlayer.prototype.setPlayerStyle = function (rect) {
        if (!this.videoElement) {
            return;
        }
        this.videoElement.style.position = 'fixed';
        this.videoElement.style.left = rect.x + "px";
        this.videoElement.style.top = rect.y + "px";
        this.videoElement.style.width = rect.width + "px";
        this.videoElement.style.height = rect.height + "px";
        this.videoElement.style.zIndex = "" + ('zIndex' in rect ? rect.zIndex : -1000);
    };
    TizenPlayer.prototype.createVideoElement = function () {
        if (this.videoElement) {
            return;
        }
        var attributes = {
            id: PLAYER_ELEMENT_ID,
            type: PLAYER_ELEMENT_TYPE,
        };
        this.videoElement = this.frameworkUtils.createElement('object', attributes);
        this.frameworkUtils.appendToBody(this.videoElement);
    };
    TizenPlayer.prototype.getAudioTracks = function () {
        return this.context.webapis.avplay
            .getTotalTrackInfo()
            .filter(function (track) { return track.type === tizen_types_1.AvPlayStreamType.Audio; })
            .map(this.transformAudioTrack);
    };
    TizenPlayer.prototype.transformAudioTrack = function (track) {
        var extraInfo = JSON.parse(track.extra_info);
        return {
            trackId: String(track.index),
            language: extraInfo.language,
        };
    };
    return TizenPlayer;
}(client_lib_js_player_addons_common_player_1.Player));
exports.TizenPlayer = TizenPlayer;
